<ion-content color="light">
  <ion-toolbar>
    <ion-title>Edit Day</ion-title>
    <ion-buttons slot="end">
      <ion-button color="light" (click)="closeModal()"
        ><ion-icon name="close-circle-outline"></ion-icon
      ></ion-button>
    </ion-buttons>
  </ion-toolbar>

  <div class="w-[90%] my-4 mx-auto">
    <form [formGroup]="editDayForm" class="space-y-4">
      <!-- <div class="my-1">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Dwell Date</label
        >
        <div class="mt-1">
          <input
            type="date"
            formControlName="dwell_date"
            class="block w-full h-12 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>
        <p
          class="mt-2 text-sm text-red-600"
          id="firstname-error"
          *ngIf="productInsertForm.get('dwell_date')?.hasError('required') && (productInsertForm.get('dwell_date')?.touched || productInsertForm.get('dwell_date')?.dirty)"
        >
          *Date is required
        </p>
      </div> -->
      <div class="my-1">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Monitoring Date<span style="color: red">*</span></label
        >
        <div>
          <input
            type="date"
            formControlName="monitoring_date"
            max="{{ today | date:'yyyy-MM-dd' }}"
            class="block mt-1 w-full h-[37px] rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>
        <p
          class="mt-2 text-sm text-red-600"
          id="firstname-error"
          *ngIf="editDayForm.get('monitoring_date')?.hasError('required') && (editDayForm.get('monitoring_date')?.touched || editDayForm.get('monitoring_date')?.dirty)"
        >
          Monitoring Date is required
        </p>
      </div>
      <!-- <div class="my-1">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Dressing Intact</label
        >
        <div class="mt-1">
          <input
            type="text"
            formControlName="dressing_intact"
            class="block w-full h-12 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>
        <p
          class="mt-2 text-sm text-red-600"
          id="firstname-error"
          *ngIf="productInsertForm.get('dressing_intact')?.hasError('required') && (productInsertForm.get('dressing_intact')?.touched || productInsertForm.get('dressing_intact')?.dirty)"
        >
          *Dressing intact is required
        </p>
      </div> -->
      <div class="my-1">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Securement</label
        >
        <div>
          <ng-select
            class="w-[100%] mt-1 rounded-md border-gray-300"
            formControlName="securement"
            [searchable]="false"
            [clearable]="false"
          >
            <ng-option [value]="null">Select an option</ng-option>
            <ng-option [value]="'Cath Securement Drsg'">Cath Securement Drsg</ng-option>
            <ng-option [value]="'None'">None</ng-option>
            <ng-option [value]="'Sutureless Securement'">Sutureless Securement</ng-option>
          </ng-select>
        </div>
        <!-- <p
        class="mt-2 text-sm text-red-600"
        id="firstname-error"
        *ngIf="productInsertForm.get('securement')?.hasError('required') && (productInsertForm.get('securement')?.touched || productInsertForm.get('securement')?.dirty)"
      >
        *Securement is required
      </p> -->
      </div>

      <div class="my-1">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Flushes</label
        >
        <div>
          <ng-select
            class="w-[100%] mt-1 rounded-md border-gray-300"
            formControlName="flushes_dropdown"
            name="flushes"
            [searchable]="false"
            [clearable]="false"
          >
            <ng-option [value]="null">Select an option</ng-option>
            <ng-option [value]="'Infusing'">Infusing</ng-option>
            <ng-option [value]="'No'">No</ng-option>
            <ng-option [value]="'Yes'">Yes</ng-option>
          </ng-select>
        </div>
        <!-- <p
          class="mt-2 text-sm text-red-600"
          id="firstname-error"
          *ngIf="productInsertForm.get('flushes')?.hasError('required') && (productInsertForm.get('flushes')?.touched || productInsertForm.get('flushes')?.dirty)"
        >
          *Flushes is required
        </p> -->
      </div>
      <div class="my-1">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Clamped</label
        >
        <div>
          <ng-select
            class="w-[100%] mt-1 rounded-md border-gray-300"
            formControlName="clamped"
            name="clamped"
            [searchable]="false"
            [clearable]="false"
          >
            <ng-option [value]="null">Select an option</ng-option>
            <ng-option [value]="'Infusing'">Infusing</ng-option>
            <ng-option [value]="'No'">No</ng-option>
            <ng-option [value]="'Yes'">Yes</ng-option>
          </ng-select>
        </div>
        <!-- <p
          class="mt-2 text-sm text-red-600"
          id="firstname-error"
          *ngIf="productInsertForm.get('clamped')?.hasError('required') && (productInsertForm.get('clamped')?.touched || productInsertForm.get('clamped')?.dirty)"
        >
          *clamped is required
        </p> -->
      </div>
      <div class="my-1">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Notes</label
        >
        <div>
          <input
            type="text"
            formControlName="notes"
            class="block mt-1 h-[37px] w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div>
        <!-- <p
          class="mt-2 text-sm text-red-600"
          id="firstname-error"
          *ngIf="productInsertForm.get('notes')?.hasError('required') && (productInsertForm.get('notes')?.touched || productInsertForm.get('notes')?.dirty)"
        >
          *Notes is required
        </p> -->
      </div>

      <div class="sm:col-span-3">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Reason of D/C
        </label>
        <div>
          <ng-select
            class="w-[100%] mt-1 rounded-md border-gray-300"
            formControlName="dc_reason"
            name="Product name"
            [items]="dcReasons"
            bindValue="id"
            bindLabel="name"
            [searchable]="false"
            [clearable]="false"
          >
            <ng-option [value]="null">Select an option</ng-option>
          </ng-select>
        </div>
        <!-- <p
          class="mt-2 text-sm text-red-600"
          id="firstname-error"
          *ngIf="productInsertForm.get('dc_reason')?.hasError('required') && (productInsertForm.get('dc_reason')?.touched || productInsertForm.get('dc_reason')?.dirty)"
        >
          Reason is required
        </p>
      </div>
      <div class="my-2 md:justify-between md:flex">
        <label
          for="first-name"
          class="block text-sm font-medium text-[#797979]"
          >Responsibility</label
        >
        <div class="mt-1 ml-1">
          <input
            type="checkbox"
            formControlName="responsibility"
            class="block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
        </div> -->

        <div class="mt-1 pt-2 flex items-center">
          <input
            type="checkbox"
            formControlName="blood_return"
            class="block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
          <label
            for="first-name"
            class="pl-1 block text-sm font-medium text-[#797979]"
            >Blood Return</label
          >
        </div>
        <div class="mt-1 flex items-center">
          <input
            type="checkbox"
            formControlName="completed_therapy"
            class="block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
          <label
            for="first-name"
            class="pl-1 block text-sm font-medium text-[#797979]"
            >Completed Therapy</label
          >
        </div>
        <div class="mt-1 flex items-center">
          <input
            type="checkbox"
            formControlName="dressing_intact"
            class="block rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
          <label
            for="first-name"
            class="pl-1 block text-sm font-medium text-[#797979]"
            >Dressing Intact</label
          >
        </div>
      </div>
    </form>
    <div
      class="pt-8 md:pt-4 flex justify-between items-center space-x-2"
    >
      <button
        (click)="closeModal()"
        class="w-full rounded-[5px] h-[40px] !bg-[#58585A] text-white"
      >
        Cancel
      </button>
      <ion-button
        [disabled]="!editDayForm.valid"
        class="w-full h-[40px] min-h-10"
        expand="block"
        (click)="submit()"
        >Edit Day</ion-button
      >
    </div>
  </div>
</ion-content>